import React from "react";
import "./Shop_by_papers_textures.css";
import CommonHeadingBeforeAfterLine from "../../Common-Component/CommonHeadingBeforeAfterLine/CommonHeadingBeforeAfterLine";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import Shop_by_papers_textures_cards from "../../Common-Component/Shop_by_papers_textures_cards/Shop_by_papers_textures_cards";

function Shop_by_papers_textures({productdata}) {
  const slides = Array(9).fill(null); // Creates an array with 9 elements

  return (
    <section className="Shop_by_papers_textures">
      <div className="custom_container">
        <CommonHeadingBeforeAfterLine headingText={"Shop by papers & textures"} />

        <div className="Shop_by_papers_textures_cards_holder">
          <Swiper
            spaceBetween={30}
            slidesPerView={4}
            breakpoints={{
              0: { slidesPerView: 1.5, spaceBetween: 10 },
              420: { slidesPerView: 2.5, spaceBetween: 10 }, 
              485: { slidesPerView: 3.5, spaceBetween: 10 },
              640: { slidesPerView: 3.5, spaceBetween: 20 },
              1024: { slidesPerView: 4, spaceBetween: 30 },
              1280: { slidesPerView: 4, spaceBetween: 40 },
            }}
          >
            {productdata.map((val, index) => (
              <SwiperSlide key={index}>
                <Shop_by_papers_textures_cards val={val}/>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
}

export default Shop_by_papers_textures;
